var map = {
	"./adult/nn/wordchain-tutorial": 643,
	"./adult/no/wordchain-tutorial": 644,
	"./child/se/wordchain-tutorial": 645,
	"./youth/de/wordchain-tutorial": 646,
	"./youth/nn/wordchain-tutorial": 647,
	"./youth/no/wordchain-tutorial": 648,
	"./youth/se/wordchain-tutorial": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642;